import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Sites from "./pages/Sites";
import Suppliers from "./pages/Suppliers";
import StockMovements from "./pages/StockMovements";
import Transfers from "./pages/Transfers";
import PurchaseOrders from "./pages/PurchaseOrders";
import Sales from "./pages/Sales";
import Payments from "./pages/Payments";
import Inventories from "./pages/Inventories";
import Batches from "./pages/Batches";
import Forecast from "./pages/Forecast";
import SuperAdmin from "./pages/SuperAdmin";
import CustomerOrders from "./pages/CustomerOrders";
import Deliveries from "./pages/Deliveries";
import PublicCatalog from "./pages/PublicCatalog";
import PublicCatalogDefault from "./pages/PublicCatalogDefault";
import DriverPortal from "./pages/DriverPortal";
import Cash from "./pages/Cash";
import Labels from "./pages/Labels";
import Scanner from "./pages/Scanner";
import Audit from "./pages/Audit";
import Users from "./pages/Users";
import SmsOutbox from "./pages/SmsOutbox";
import Diagnostics from "./pages/Diagnostics";
import { Toaster } from "sonner";

function Shell({ children, roles }) {
  return <ProtectedRoute roles={roles}><Layout>{children}</Layout></ProtectedRoute>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* === PAGES PUBLIQUES (visibles par les visiteurs) === */}
            <Route path="/" element={<PublicCatalogDefault />} />
            <Route path="/boutique/:slug" element={<PublicCatalog />} />
            <Route path="/boutique" element={<PublicCatalogDefault />} />
            <Route path="/chauffeur/:token" element={<DriverPortal />} />

            {/* === ESPACE ADMIN MASQUÉ === */}
            {/* URL de connexion secrète (à partager uniquement à la cliente et au support) */}
            <Route path="/portail-admin" element={<Login />} />
            {/* Anciennes URLs admin → redirigent vers le catalogue pour masquer */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/inscription" element={<Navigate to="/" replace />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />

            {/* === DASHBOARDS PROTÉGÉS === */}
            <Route path="/admin" element={<Shell><Dashboard /></Shell>} />
            <Route path="/produits" element={<Shell><Products /></Shell>} />
            <Route path="/stock" element={<Shell><StockMovements /></Shell>} />
            <Route path="/transferts" element={<Shell><Transfers /></Shell>} />
            <Route path="/sites" element={<Shell><Sites /></Shell>} />
            <Route path="/fournisseurs" element={<Shell roles={["admin"]}><Suppliers /></Shell>} />
            <Route path="/commandes" element={<Shell roles={["admin"]}><PurchaseOrders /></Shell>} />
            <Route path="/ventes" element={<Shell><Sales /></Shell>} />
            <Route path="/paiements" element={<Shell><Payments /></Shell>} />
            <Route path="/inventaires" element={<Shell><Inventories /></Shell>} />
            <Route path="/lots" element={<Shell><Batches /></Shell>} />
            <Route path="/predictions" element={<Shell><Forecast /></Shell>} />
            <Route path="/super-admin" element={<Shell roles={["admin"]}><SuperAdmin /></Shell>} />
            <Route path="/commandes-clients" element={<Shell><CustomerOrders /></Shell>} />
            <Route path="/livraisons" element={<Shell><Deliveries /></Shell>} />
            <Route path="/caisse" element={<Shell><Cash /></Shell>} />
            <Route path="/etiquettes" element={<Shell><Labels /></Shell>} />
            <Route path="/scanner" element={<Shell><Scanner /></Shell>} />
            <Route path="/audit" element={<Shell roles={["admin"]}><Audit /></Shell>} />
            <Route path="/utilisateurs" element={<Shell roles={["admin"]}><Users /></Shell>} />
            <Route path="/sms" element={<Shell roles={["admin"]}><SmsOutbox /></Shell>} />
            <Route path="/diagnostics" element={<Shell roles={["admin"]}><Diagnostics /></Shell>} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" position="top-center" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E2E7E4", color: "#020A18", borderRadius: 12 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
